module.exports = __webpack_public_path__ + "img/warn-modal-icon.ccb28866.svg";